import Swiper from "swiper/bundle";
import "swiper/css/bundle";

const swiperBanner = new Swiper(".swiper-banner-home", {
  slidesPerView: 1,
  speed: 1000,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 20000,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + "</span>";
    },
  },
});

export const swiperVideo = new Swiper(".swiper-video", {
  spaceBetween: 5,
  loop: true,
  breakpoints: {
    345: {
      centeredSlides: true,
      slidesPerView: 1.4,
    },
    768: {
      centeredSlides: false,
      slidesPerView: 1.8,
    },
    1024: {
      slidesPerView: 3,
    },
    1440: {
      slidesPerView: 3.4,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

export const swiperRelatedFour = new Swiper(".swiper-four-slide", {
  spaceBetween: 10,
  loop: true,
  breakpoints: {
    345: {
      centeredSlides: true,
      slidesPerView: 1.4,
    },
    640: {
      slidesPerView: 1.8,
    },
    768: {
      slidesPerView: 2.4,
    },
    1024: {
      centeredSlides: false,
      slidesPerView: 3,
    },
    1440: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
export const swiperRelatedThird = new Swiper(".swiper-third-slide", {
  spaceBetween: 10,
  loop: true,
  breakpoints: {
    345: {
      centeredSlides: true,
      slidesPerView: 1.4,
    },
    640: {
      slidesPerView: 1.8,
    },
    768: {
      slidesPerView: 2.4,
      spaceBetween: 80,
    },
    1024: {
      centeredSlides: false,
      spaceBetween: 100,
      slidesPerView: 3,
    },
    1440: {
      spaceBetween: 200,
      slidesPerView: 3,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
export const swiperVideoProduct = new Swiper(".swiper-video-product", {
  spaceBetween: 5,
  loop: true,
  centeredSlides: true,
  breakpoints: {
    345: {
      slidesPerView: 1.4,
    },
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 4,
    },
    1440: {
      slidesPerView: 5,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
export const swiperCharacteristics = new Swiper(".swiper-characteristics", {
  spaceBetween: 10,
  loop: true,
  breakpoints: {
    345: {
      centeredSlides: true,
      slidesPerView: 1.4,
    },
    640: {
      slidesPerView: 1.8,
    },
    768: {
      slidesPerView: 2.4,
    },
    1024: {
      centeredSlides: false,
      slidesPerView: 3,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
